export default __webpack_public_path__ + "static/media/table-sort-caret-down.d999d20e.svg";